import LogoUrl from '../../../assets/images/logo-big.avif';
import { UnauthLayout } from '@/components/auth/unauth-layout';

interface SignupLoadingViewProps {
	isModal: boolean;
	isMobile: boolean;
	isParentConsentSubmitting: boolean;
}

export function SignupLoadingView({
	isModal,
	isMobile,
	isParentConsentSubmitting,
}: SignupLoadingViewProps) {
	const content = (
		<>
			<img src={LogoUrl} alt="SportsPredict.com" className="mb-10" />
			<p className="text-2xl font-[700]">Welcome to</p>
			<p className="orbitron-title text-3xl text-center">SportsPredict.com</p>
			<span
				className="mt-6 h-6 w-6 animate-spin rounded-full border-2 border-[#ACC0F6] border-t-transparent"
				aria-hidden="true"
			/>
			<p className="font-[200] text-sm mt-3">
				{isParentConsentSubmitting
					? 'Sending the approval request, hang on a sec...'
					: 'Redirecting you, hang on a sec...'}
			</p>
		</>
	);

	if (isModal) {
		return (
			<div
				className="flex min-h-[480px] w-full flex-col items-center justify-center bg-[#101423] p-5 text-[#F7F7F8] font-['DM_Sans']"
				role="status"
				aria-live="polite"
			>
				{content}
			</div>
		);
	}

	if (isMobile) {
		return (
			<div
				className="flex flex-col items-center justify-center min-h-screen bg-[#171C26] bg-cover bg-center bg-no-repeat p-5 pb-10 text-[#F7F7F8] font-['DM_Sans']"
				role="status"
				aria-live="polite"
			>
				{content}
			</div>
		);
	}

	return (
		<UnauthLayout panelClassName="bg-[#101423] p-5 pb-10 text-[#F7F7F8] font-['DM_Sans'] flex-col justify-center">
			<div className="flex flex-col items-center" role="status" aria-live="polite">
				{content}
			</div>
		</UnauthLayout>
	);
}
